var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeadset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2222 3.70005C8.75764 3.70005 7.35304 4.28185 6.31742 5.31747C5.28181 6.35309 4.7 7.75769 4.7 9.22227V9.46797C4.96384 9.35973 5.25273 9.30005 5.55556 9.30005C6.80127 9.30005 7.81111 10.3099 7.81111 11.5556V13.1112C7.81111 14.3569 6.80127 15.3667 5.55556 15.3667C4.30985 15.3667 3.3 14.3569 3.3 13.1112V11.5556V9.22227C3.3 7.38638 4.02931 5.62569 5.32747 4.32752C6.62564 3.02935 8.38634 2.30005 10.2222 2.30005C12.0581 2.30005 13.8188 3.02935 15.117 4.32752C16.4151 5.62569 17.1444 7.38638 17.1444 9.22227V11.5556L17.1444 11.5579V13.1112C17.1444 14.1501 16.442 15.025 15.4861 15.2868C15.2421 16.0039 14.5911 16.5647 13.8351 16.9428C12.8404 17.4401 11.5405 17.7001 10.2222 17.7001C9.83559 17.7001 9.52219 17.3867 9.52219 17.0001C9.52219 16.6135 9.83559 16.3001 10.2222 16.3001C11.3792 16.3001 12.4533 16.0684 13.209 15.6906C13.5668 15.5116 13.8016 15.3294 13.9515 15.1633C13.1737 14.8074 12.6333 14.0224 12.6333 13.1112V11.5556C12.6333 10.3099 13.6432 9.30005 14.8889 9.30005C15.1917 9.30005 15.4806 9.35973 15.7444 9.46797V9.22227C15.7444 7.75769 15.1626 6.35309 14.127 5.31747C13.0914 4.28185 11.6868 3.70005 10.2222 3.70005ZM4.7 13.1112V11.5556C4.7 11.0831 5.08305 10.7 5.55556 10.7C6.02807 10.7 6.41111 11.0831 6.41111 11.5556V13.1112C6.41111 13.5837 6.02807 13.9667 5.55556 13.9667C5.08305 13.9667 4.7 13.5837 4.7 13.1112ZM14.0333 11.5556C14.0333 11.0831 14.4164 10.7 14.8889 10.7C15.3614 10.7 15.7444 11.0831 15.7444 11.5556V13.1112C15.7444 13.5837 15.3614 13.9667 14.8889 13.9667C14.4164 13.9667 14.0333 13.5837 14.0333 13.1112V11.5556Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 4.8575,
    y1: 5.18755,
    x2: 15.4371,
    y2: 6.03103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD3C2F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeadset);
export default __webpack_public_path__ + "static/media/icon_headset.1cf0a3c6a0c258bc81a16abfd73724c3.svg";
export { ForwardRef as ReactComponent };